import { useMutation, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import {
  createMatrix,
  getMatrix,
  getUpdateMatrix,
  updateMatrixIntercompanyInvoice,
  updateMatrixMichelinSupplier,
} from './Matrix.service';

import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { RegisterMatrix } from '@/types/Register';
import notificationError from '@/utils/functions/notificationError';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { queryClient } from '@/Root';

export function useCreateMatrix() {
  const intl = useIntl();

  const mutation = useMutation((obj: RegisterMatrix) => createMatrix(obj), {
    onSuccess() {
      notification.success({
        message: intl.formatMessage({
          id: 'register.form.notification.success',
        }),
        description: intl.formatMessage({
          id: 'register.form.notification.successDescription',
        }),
      });
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useMatrix(enabled = true) {
  const cache = queryClient.getQueryData(['matrix-settings']);

  return useQuery(['matrix-settings'], () => getMatrix(), {
    enabled: !cache && enabled,
    onError(error) {
      notificationError(error);
    },
  });
}

export function useMatrixUpdate() {
  const queryChanel = useQueryChanel();

  const query = useMutation(getUpdateMatrix, {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Configuração de sistema alterada com sucesso!',
      });

      queryChanel({
        resetQueries: ['matrix-settings'],
      });
    },
  });

  useServiceError(query.error);

  return query;
}

export function useUpdateMatrixIntercompanyInvoice() {
  const queryChanel = useQueryChanel();

  return useMutation(updateMatrixIntercompanyInvoice, {
    onSuccess() {
      notification.success({
        message: 'Configuração fiscal atualizado com sucesso!',
      });

      queryChanel({
        resetQueries: ['matrix-settings'],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useUpdateMatrixMichelinSupplier() {
  const queryChanel = useQueryChanel();

  return useMutation(updateMatrixMichelinSupplier, {
    onSuccess() {
      notification.success({
        message: 'Fornecedor padrão Michelin atualizado com sucesso!',
      });

      queryChanel({
        resetQueries: ['matrix-settings'],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
